import React from 'react'
import { __ } from '@wordpress/i18n'
import PropTypes from 'prop-types'
import Button from '../Button'
import { ReactComponent as SearchIcon } from '../../../gutenberg/blocks/search-teaser/search-icon.svg'
import { ReactComponent as SearchIconMap } from '../../../gutenberg/blocks/search-teaser/search-icon-map.svg'
import { ReactSVG } from 'react-svg'

const SearchTeaser = ({
  title,
  description,
  link,
  compactIcon,
  customIcon,
  icon,
  classList,
}) => {
  const isLinkURL = () => {
    if (link) {
      if (link.url) {
        return true
      }
    }
    return false
  }

  return (
    <div className={classList}>
      <div className="--image">
        {!customIcon ? (
          compactIcon ? (
            <SearchIcon />
          ) : (
            <SearchIconMap />
          )
        ) : icon && icon.mime == 'image/svg+xml' ? (
          <ReactSVG src={icon.url} loading={() => <span>Loading</span>} />
        ) : (
          <img
            src={icon.url}
            width={icon.width}
            height={icon.height}
            alt={icon.alt}
          />
        )}
      </div>
      <h3 className="--title" dangerouslySetInnerHTML={{ __html: title }} />
      <p
        className="--description"
        dangerouslySetInnerHTML={{ __html: description }}
      />
      {isLinkURL() && (
        <Button
          url={link.url}
          target={link.opensInNewTab ? '_blank' : ''}
          style="primary"
          icon
        >
          {link.title ? link.title : __('Suchagenten starten', 'dhsv_blocks')}
        </Button>
      )}
    </div>
  )
}

SearchTeaser.defaultProps = {
  isPreview: false,
  isSelected: false,
}

SearchTeaser.propTypes = {
  icon: PropTypes.object,
  link: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  description: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  isSelected: PropTypes.bool,
  isPreview: PropTypes.bool,
  compactIcon: PropTypes.bool,
  customIcon: PropTypes.bool,
  classList: PropTypes.string,
}

export default SearchTeaser
